import { Variant } from "@/types/types";

type BundleVariant = Extract<Variant, { __typename: "CompositeBundleVariant" }>;

export type BundleServices =
  BundleVariant["components"][0]["variant"]["services"];

export function getBundleServices(variant: BundleVariant): BundleServices {
  return variant.components[0]?.variant.services || [];
}
